export function getMessageByError(ex: Error): string {
  return ex.message;
}
